var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("multi-select", {
    ref: "multiSelect",
    attrs: {
      options: _vm.options,
      "selected-options": _vm.selectedOptions,
      placeholder: _vm.placeholder,
    },
    on: { select: _vm.onSelect, searchchange: _vm.onSearchChange },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }